import { render, staticRenderFns } from "./AdditionalFeatures.vue?vue&type=template&id=013f52e5"
import script from "./AdditionalFeatures.vue?vue&type=script&lang=js"
export * from "./AdditionalFeatures.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFeatures.vue?vue&type=style&index=0&id=013f52e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports